module.exports = __webpack_public_path__ + "static/media/p1.be1ec0e1.jpg";